import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const routes = {
  memoryCash: (caseId: number) => `/v1/memorycash?id=${caseId}`
};

@Injectable({
  providedIn: 'root'
})
export class CaseLockService {

  constructor(private http: HttpClient) { }

  unlockCase(caseId: number): Observable<any> {
    return this.http.delete(routes.memoryCash(caseId));
  }
}

